import React from 'react';
import { XIcon, ArrowDownIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { CtaBlock } from '../CtaBlock';
import { decisionPathway } from '../../data/content';
const notThis = ['It’s not another manual.', 'It’s not another course.', 'It’s not a summary of clinical guidelines.'];
export function SolutionSection() {
  return <section className="bg-navy-950 py-14 text-white sm:py-20" aria-labelledby="solution-title" data-id="element-271" data-mp="19zg3i27ueeq5">
      <div className="mx-auto w-full max-w-4xl px-4 sm:px-6" data-id="element-272" data-mp="d9ovd06mot1v">
        <SectionHeading tone="dark" eyebrow="The solution" title={<span id="solution-title" data-id="element-274" data-mp="mbeoqbk2m22a">
              Imagine what your consultations would feel like if every important clinical decision
              was already mapped out.
            </span>} data-id="element-273" data-mp="ibeaaqwz1qv8" />

        <ul className="mx-auto mt-8 max-w-md space-y-2 text-center text-[15px] font-semibold text-navy-100 sm:text-lg" data-id="element-275" data-mp="3qq62hzla0jcm">
          <li data-id="element-276" data-mp="3upnap0s37ulh">No more second-guessing.</li>
          <li data-id="element-277" data-mp="32l7mlw4pa6v5">No more endless searches.</li>
          <li data-id="element-278" data-mp="32n0q52k0oayx">No more worrying about overlooking an important recommendation.</li>
        </ul>

        <p className="mx-auto mt-6 max-w-2xl text-pretty text-center text-[15px] leading-relaxed text-navy-200 sm:text-lg" data-id="element-279" data-mp="2xnxxkhl83x7u">
          Just open the right algorithm, follow the clinical pathway, and make an evidence-based
          decision. That is exactly what the Clinical Decision System for Diabetes does.
        </p>

        <ul className="mt-8 grid gap-3 sm:grid-cols-3" data-id="element-280" data-mp="2evd8zcck4e9u">
          {notThis.map(item => <li key={item} className="flex items-center gap-2 rounded-xl border border-white/10 bg-white/5 px-4 py-3 text-sm font-semibold text-navy-100" data-id="element-281" data-mp="2expvm2t9fct8">
              <XIcon className="h-4 w-4 shrink-0 text-alert-500" aria-hidden="true" data-id="element-282" data-mp="24zikw1pkdqzo" />
              {item}
            </li>)}
        </ul>

        <div className="mt-10 rounded-3xl border border-clinic-500/40 bg-clinic-500/10 p-5 text-center sm:p-8" data-id="element-283" data-mp="36uejjhminfo">
          <p className="text-[11px] font-black uppercase tracking-[0.16em] text-clinic-300 sm:text-xs" data-id="element-284" data-mp="1xkgcfuej1kp4">
            It is a system designed to answer one question:
          </p>
          <p className="mt-3 text-balance text-xl font-black leading-tight tracking-tight sm:text-2xl" data-id="element-285" data-mp="1nomtnta7suyw">
            “What is the correct next step for this patient?”
          </p>
        </div>

        <h3 className="mt-12 text-center text-base font-bold text-white sm:text-lg" data-id="element-286" data-mp="2gc97dud5pfzh">
          Thousands of clinical decisions organized into one visual system.
        </h3>

        <ol className="mt-6 space-y-2" data-id="element-287" data-mp="26elaaxs2vwe5">
          {decisionPathway.map((step, i) => <li key={step} data-id="element-288" data-mp="2bdfqrt2kp8v3" data-mpi={i}>
              <div className="flex items-center gap-3 rounded-2xl bg-white/[0.06] px-4 py-3.5" data-id="element-289" data-mp="2bcmslghojrok">
                <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-lg bg-clinic-500 text-sm font-black text-white" data-id="element-290" data-mp="uyo662bo55wc">
                  {i + 1}
                </span>
                <span className="text-[15px] font-bold text-white sm:text-base" data-id="element-291" data-mp="3e5s2joxssdum">{step}</span>
              </div>
              {i < decisionPathway.length - 1 && <div className="flex justify-center py-1" aria-hidden="true" data-id="element-292" data-mp="3991iyrmsb04g">
                  <ArrowDownIcon className="h-4 w-4 text-clinic-400" data-id="element-293" data-mp="3n66o8peobuyn" />
                </div>}
            </li>)}
        </ol>

        <p className="mt-8 text-center text-sm font-semibold text-navy-200 sm:text-base" data-id="element-294" data-mp="2vfalihmbv6p3">
          Everything is organized so you can find the answer in minutes — not hours.
        </p>

        <CtaBlock tone="dark" kicker="Turn every complex consultation into a clear decision-making pathway." label="👉 I want the complete system" data-id="element-295" data-mp="347ubktok02yb" />
      </div>
    </section>;
}